import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {
  ModalOverlay,
  ModalContent,
  Header,
  HeaderActions,
  DocumentName,
  DocumentInfo,
  CloseButton,
} from './DocumentContentModal.styled';
import MenuButtonWrapper from '../../../../../elements/v2/MenuButtonWrapper';

const DocumentContentModal = ({ isOpen, onClose, documentData }) => {
  if (!isOpen) return null;

  const menuItems = [
    { label: 'Download', onClick: () => console.log('Download clicked') },
    { label: 'Share', onClick: () => console.log('Share clicked') },
    { label: 'Delete', onClick: () => console.log('Delete clicked') },
  ];

  return (
    <ModalOverlay 
      onClick={onClose}
      data-testid="modal-overlay"
    >
      <ModalContent 
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="document-title"
      >
        <Header>
          <DocumentName id="document-title">{documentData?.name || 'Document Name'}</DocumentName>
          <HeaderActions>
            <MenuButtonWrapper items={menuItems} />
            <CloseButton 
              onClick={onClose}
              aria-label="close"
            >
              <CloseIcon />
            </CloseButton>
          </HeaderActions>
        </Header>

        <DocumentInfo>
          <span>Size: {documentData?.size || '0 KB'}</span>
          <span>Last Updated: {documentData?.last_updated || 'N/A'}</span>
        </DocumentInfo>
      </ModalContent>
    </ModalOverlay>
  );
};

export default DocumentContentModal; 